import LocalizedStrings from "react-localization";

export default new LocalizedStrings({
	/* cSpell:enable */
	/* cSpell.language:pt,pt_PT */
	pt: {
		// Generic
		generic: {
			edit: "Editar",
			done: "Concluir",
			accept: "Aceitar",
			cancel: "Cancelar",
			remove: "Remover",
			delete: "Eliminar",
			success: "Sucesso",
			active: "Ativar",
			expand: "Expandir",
			toggle: "Toggle",
			save: "Guardar",
			yes: "Sim",
			no: "Não",
			apply: "Aplicar",
			item: "Artigo",
			items: "Artigos",
			submit: "Submeter",
			continue: "Continuar",
			confirm: "Confirmar",
			finish: "Terminar",
			back: "Voltar",
			oops: "Oops",
			error: "Erro",
			retry: "Tentar novamente",
			reset: "Reset",
			search: "Pesquisar",
			noResults: "Sem Resultados",
			clickHereTo: "Clique aqui para {0}",
			requiredField: "{0} é um campo obrigatório",
			duplicateEmail: "Este email já está a ser utilizado. Por favor utilize outro email.",
			emptyList: "Sem {0} na lista",
			leavePage: "Sair da Página?",
			leave: "Sair",
			stay: "Ficar",
			open: "Abrir",
			close: "Fechar",
			change: "Mudar",
			free: "Grátis",
			send: "Enviar",
			selected: "Selecionado",
			selecteds: "Selecionados",
			swalEditTitle: "Cancelar Alteração?",
			swalEditDescription: "Cancelar edição vai apagar toda a informação não guardada",
			leaveDescription: "Ao sair desta página vai apagar toda a informação não guardada",
			swalDeleteTitle: "Apagar {0}?",
			swalDeleteDescription: "Ao sair desta página vai apagar todos os {0} na sua lista",
			genericSelect: "Selecionar {0}",
			select: "Selecionar",
			addGeneric: "Adicionar {0}",
			moreOptions: "Mais Opções",
			all: "Tudo",
			enable: "Ativar",
			newF: "Nova",
			newM: "Novo",
			addNewF: "Adicionar nova {0}",
			addNewM: "Adicionar novo {0}",
			addNew: "Adicionar {0}",
			default: "Pré-Definido",
			editGeneric: "Editar {0}",
			infinite: "Infinito",
			details: "Detalhes",
			noItemsSelected: "Nenhum Item Selecionado",
			clearList: "Limpar lista",
			loading: "A Carregar...",
			view: "Ver",
			actions: "Ações",
			invalidUrl: "URL inválido. Por favor remova o prefixo HTTP.",
			shop: "Loja",
			noEntries: "Sem Valores",
			chatWalktroughText1:
				"Adicionámos diversas FAQ que podem ajudar a conhecer e entender como funciona o produto Shop2Grow. Essas FAQ estão disponíveis no ícone de chat no canto inferior direito do ecrã.",
			chatWalktroughText2:
				"Estamos também disponíveis, através de chat, para ajudar na melhor maneira de criar e definir a sua loja.",
			skip: "Saltar Walkthrough",
			walkTrough: "Walkthrough",
			clone: "Clonar",
			download: "Download",
			upload: "Upload",
			template: "Download Template",
			export: "Exportar",
			import: "Importar",
			defaultItem: "um item",
			defaultItemRecipient: "este/esta {0}",
			demo: "Demo",
			previewOnly: "Apenas Preview",
			selectPaymentMethod: "Por favor, selecione um método de pagamento antes de atualizar a sua subscrição.",
			basic: "Básico",
			advanced: "Avançado",
			editMode: "Modo de Edição",
			print: "Imprimir",
			code: "Codigo",
			percentage: "Percentagem",
			yesDelete: "Sim, apagar!"
		},

		fields: {
			name: "Nome",
			address: "Morada",
			addresses: "Moradas",
			country: "País",
			state: "Distrito",
			counties: "Concelhos",
			county: "Concelho",
			city: "Cidade",
			type: "Tipo",
			zipCode: "Código Postal",
			description: "Descrição",
			phone: "Telefone",
			phoneNumber: "Número de Telefone",
			phoneShort: "Tel.:",
			mobilePhone: "Telemóvel",
			email: "Email",
			acceptMarketing: "Marketing",
			seoUrl: "SEO Url",
			tags: "Tags",
			ccNumber: "Número do CC",
			billingAddress: "Morada de Faturação",
			shippingAddress: "Morada de Envio",
			vat: "VAT",
			password: "Password",
			message: "Mensagem",
			image: "Imagem",
			images: "Imagens",
			logo: "Logo",
			imgPlaceholder: "Tente arrastar imagens para aqui, ou clique para fazer upload",
			filesPlaceholder: "Tente arrastar o ficheiro para aqui ou clique para selecionar o ficheiro",
			subTotal: "Subtotal",
			total: "Total",
			quantity: "Quantidade",
			ordered: "Qtd. Encomendada",
			totalQuantity: "Quantidade Total",
			discount: "Desconto",
			registerDate: "Data Registo",
			invalidEmail: "Email não é valido",
			tax: "Taxa",
			addedOn: "Adicionado",
			startDate: "Data Inicial",
			endDate: "Data Final",
			startHour: "Hora Inicial",
			endHour: "Hora Final",
			filename: "Nome do Ficheiro",
			gender: "Género",
			waitingForResults: "À espera do nome ou SKU...",
			link: "Link",
			date: "Data",
			otherRegions: "Outras Zonas",
			taxValues: "Taxas",
			previewLink: "Link de Pré-Visualização",
			clickToUpload: "Clique para fazer o Upload",
			photo: "Foto",
			file: "Ficheiro",

			// Select
			selectCountry: "Selecionar País",
			selectState: "Selecionar Estado",
			selectFilters: "Selecionar Filtros",
			selectDiscount: "Selecionar Desconto",

			countries: "Países",
			states: "Distritos",

			// Pairs
			valuePair: "{0} / {1}",
			placeHolderPair: "{0} => {1}",

			code: "Abreviatura",
			bccEmail: "Email para receber encomendas"
		},

		language: {
			header: "Idioma",
			defaultLanguage: "Idioma Padrão",
			languageNotActive: "Guarde as atualizações antes de proceder à alteração do idioma padrão.",
			portuguese: "Português",
			english: "Inglês",
			german: "Alemão",
			french: "Francês",
			spanish: "Espanhol",
			greek: "Grego"
		},

		sidebar: {
			dashboard: "Dashboard",
			profile: "Perfil",
			information: "Informação",
			promoters: "Promotores",
			settings: "Definições",
			logs: "Logs",
			users: "Utilizadores",
			staff: "Staff",
			products: "Produtos",
			cultures: "Culturas",
			nutrients: "Nutrientes",
			news: "Noticias",
			formations: "Biblioteca",
			notifications: "Notificações",
			documents: "Documentos",
			fertilizingTypes: "Tipos de Fertilizante"
		},

		header: {
			daysLeft: "dias restantes de trial",
			upgrade: "Upgrade",
			account: "Conta",
			maintenance: "Manutenção",
			visitStore: "Visitar Loja",
			deleteSuccess: "Dados Temporários apagados com sucesso",
			extend: "Aumentar Trial"
		},

		// Screens
		authentication: {
			welcome: "Bem-vindo",
			header: "Autenticação",
			register: "Registo",
			login: "Login",
			logout: "Logout",
			signIn: "Autenticar",
			confirmAccount: "Confirmar Conta",
			name: "Nome",
			namePlaceholder: "O seu nome",
			email: "Email",
			emailPlaceholder: "O seu email",
			password: "Password",
			passwordPlaceholder: "A sua password",
			newPassword: "Nova password",
			newPasswordPlaceholder: "Inserir nova password",
			confirmPassword: "Confirmar Password",
			confirmPasswordPlaceholder: "Repetir a password",
			forgotPassword: "Esqueceu-se da password?",
			loginFooter: "Não tem conta? Registe-se aqui",
			registerFooter: "Já tem conta? Autentique-se aqui.",
			resendCode1: "Não recebeu o seu código de confirmação? ",
			resendCode2: "Reenviar código de ativação",
			sendEmail: "Enviar Email",
			recoverPassword: "Recuperar password",
			changePassword: "Mudar Password",
			changeEmail: "Mudar Email",
			newEmail: "Novo Email",
			newEmailConfirm: "Confirmar Novo Email",
			repeatEmail: "Repetir Email",
			currentEmail: "Email Atual",
			currentPassword: "Password Atual",
			emailSent: "Email Enviado com Sucesso",
			repeatPassword: "Repetir Password",
			rememberedPassword: "Lembrou-se da password?",
			adminPassword: "Password do Administrador",
			notLoggedIn: "Necessita de estar autenticado para ter acesso a esta página",
			noMatchPassword: "As passwords não coincidem",
			acceptSubtitle: "Por favor insira uma password para confirmar a sua conta.",
			goBackToLogin: "Ir para o ecrã de início de sessão",
			resendInviteEmail: "Reenviar email de convite",
			confirmResendInviteEmail: "Reenviar email de convite para {0}?"
		},

		acceptInvite: {
			header: "Aceitar Convite",
			title: "Olá {0}, {1} convidou-o(a) a gerir {2}.",
			subTitle: "Insira uma password para confirmar a sua conta",
			expired: "Este convite expirou"
		},

		notFound: {
			header: "Página Inexistente"
		},

		importModal: {
			fileName: "Nome do Ficheiro",
			size: "Tamanho",
			import: "Importar"
		},

		errors: {
			invalidArgs: "Argumentos inválidos ou em falta",
			invalidFields: "Campos inválidos ou em falta",
			emailIsInvalid: "O formato de email inserido não é válido",
			videoUrlIsInvalid: "O formato de url inserido não é válido",
			fillEmail: "Insira um email por favor",
			fillPassword: "Insira uma password por favor",
			pleaseFillFormCorrectly: "Por favor preencha o formulário correctamente",
			fillField: "Este campo é de preenchimento obrigatório",
			notSupportedFile: "Tipo de ficheiro não suportado",
			nameIsEmpty: "O campo nome é de preenchimento obrigatório",
			passwordsDontMatch: "Os campos 'Nova password' e 'Confirmar password' não coincidem",
			emailIsEmpty: "O campo email é de preenchimento obrigatório",
			fileTooBigorInvalid: "O tamanho da imagem é superior a 8MB ou tem um formato inválido",
			couldNotImportProduct: "Não foi possível importar produtos",
			selectCountryFirst: "selecione primeiro o país",
			cantDrag: "Não é permitido ordernar elementos neste momento"
		},

		profile: {
			profilePicture: "Foto de Perfil",
			role: "Cargo",
			editedSuccessfully: "Perfil editado com sucesso"
		},

		placeholders: {
			name: "O seu nome",
			email: "o_seu@email.com",
			phoneNumber: "+351265000000",
			language: "Selecione uma língua",
			role: "Selecione um cargo",
			currentPassword: "password actual",
			newPassword: "nova password",
			confirmPassword: "nova password",
			newEmail: "novo@email.com",
			page: "pagina",
			titlePage: "Título da Página",
			link: "https://www.google.com/"
		},

		staff: {
			owner: "Dono",
			admin: "Administrador",
			editedSuccessfully: "Staff editado com sucesso",
			passwordChangedSuccessfully: "Password editada com sucesso",
			emailChangedSuccessfully: "Email editado com sucesso",
			wrongPassword: "Password errada",
			emailInUse: "Email em uso",
			status: "Estado",
			confirmed: "Confirmado",
			pending: "Pendente"
		},

		ranges: {
			today: "Hoje",
			thisMonth: "Este mês",
			lastMonth: "Último mês",
			thisYear: "Este ano",
			lastYear: "Último ano"
		},

		dashboard: {
			period: "Período",
			active: "Ativo",
			homepage: "Homepage",
			inStock: "Em Stock",
			daily: "Diário",
			monthly: "Mensal",
			newUsers: "Novos Utilizadores",
			newUsersContent: "Novos Utilizadores Conteúdo",
			uses: "Utilizações",
			androidUse: "Utilização Android",
			androidUseContent: "Utilização Android Conteúdo",
			iOSUse: "Utilização iOS",
			iOSUseContent: "Utilização iOS Conteúdo",
			webUse: "Utilização Web",
			webUseContent: "Utilização Web Conteúdo"
		},

		settings: {
			pages: "Páginas",
			emailTemplates: "Templates de E-mails",
			soilNutrients: "Nutrientes do Solo",
			fertilizingTypes: "Tipos de Fertilizante",
			lines: "Modos de aplicação",
			dichotomousKey: "Chave Dicotómica",
			agronomicServices: "Serviços Agronómicos",
			libraryTypes: "Tipos de Biblioteca"
		},

		pages: {
			single: "Página",
			title: "Título",
			content: "Conteúdo",
			new: "Nova Página",
			isLink: "Redirecionamento"
		},

		lines: {
			header: "Modo de aplicação",
			icon: "Icon"
		},

		templates: {
			single: "Template"
		},

		emails: {
			single: "E-mail",
			tags: "Tags",
			preview: "Pré-visualização",
			subject: "Assunto",
			cc: "CC"
		},

		cultures: {
			header: "Cultura",
			file: "Ficheiro da cultura",
			// deficiencies: "Carências",
			deficiencies: "Recomendações",
			deficiency: "Recomendação",

			correctionOfDeficiency: "Correções da Carência",
			symptoms: "Sintomas",
			symptom: "Sintoma",
			noSymptomsAdded: "Sem Sintomas Adicionados",
			correction: "Correção",
			noCorrectionsAdded: "Sem Correções Adicionadas",
			// toxicities: "Toxicidades",
			toxicities: "Biotecnológicos",
			toxicity: "Biotecnológico",
			// toxicity: "Toxicidade",
			correctionOfToxicity: "Correções da Toxicidade",
			mostImportantNutrients: "Nutrientes Importantes",
			nutrientsRemovel: "Extração de nutrientes",
			imageLandscape: "Imagem de Cabeçalho"
		},

		fertilizing: {
			header: "Adubação",
			productionDestiny: "Destino da Produção",
			usualProduction: "Adubação habitual",
			expectedProduction: "Adubação esperada",
			production: "Produção",
			season: "Época",
			doses: "Doses",
			dose: "Dose",
			maxConcentration: "Concentração Máxima",
			observations: "Observações",
			fertilizingType: "Tipo de Adubação"
		},

		soilFertility: {
			header: "Fertilidade do solo"
		},

		nutrients: {
			header: "Nutriente",
			value: "Valor",
			valueLimitError: "O valor deverá ser inferior a 1000",
			formula: "Formula Química"
		},

		soilNutrients: {
			header: "Nutriente do Solo",
			veryFrequent: "Muito Frequente",
			frequent: "Frequente",
			lessFrequent: "Menos Frequente"
		},

		fertilizingTypes: {
			header: "Tipo de Fertilizante"
		},

		libraryTypes: {
			header: "Tipo de Biblioteca"
		},

		dichotomousKeys: {
			header: "Chave Dicotómica",
			name: "Nome",
			description: "Description",
			createKey: "Crie uma Chave Dicotómica",
			createName: "Indique o Nome",
			createDescription: "Indique a Descrição",
			warning: "Como tem um nutriente selecionado não pode criar mais chaves filhas"
		},

		agronomicServices: {
			header: "Serviço Agronómico",
			attachedFiles: "Ficheiros do Serviço",
			analysisTypes: "Tipos de Análise",
			analisysType: "Tipo de Análise",
			observation: "Observação",
			values: "Valores",

			//Analisys Types
			complete: "Completa",
			routine: "Rotina",
			special: "Especial"
		},

		products: {
			header: "Produto",
			shortInfo: "Pequena descrição do Produto",
			generalInfo: "Informação Geral do Produto",
			files: "Ficheiros do produto",
			advantages: "Vantagens do produto",
			formulas: "Fórmulas",
			formula: "Fórmula",
			formulaInformation: "Informação",
			formulaMoreInformation: "Mais Informação",
			formulaFiles: "Ficheiros da fórmula",
			formulaFile: "Ficheiro da fórmula",
			fertiberiaProduct: "Produto Fertiberia",
			adpProduct: "Produto ADP",
			productAvailability: "Disponibilidade do Produto",
			formulaAvailability: "Disponibilidade da Fórmula",
			availablePortugal: "Disponível em Portugal",
			availableSpain: "Disponível em Espanha",
			availableFrance: "Disponível em França",
			availableGreece: "Disponível em Grécia",
			availableOthers: "Disponível noutros",
			color: "Cor do Produto",
			cropsAndDoses: "Culturas e dosagens",
			doses: "Dosagens",
			dose: "Dosagem",
			cropAndDose: "Cultura e dosagem",
			noCropsWithDosesAdded: "Sem Culturas e doses adicionados",
			slogan: "Slogan"
		},

		documents: {
			header: "Documento",
			file: "Ficheiro",
			documents: "Documentos"
		},

		news: {
			header: "Notícia",
			schedulePublication: "Agendar Publicação",
			shortDescription: "Pequena Descrição da Notícia",
			primaryImage: "Imagem Principal",
			secondaryImage: "Imagem dos Detalhes"
		},

		notifications: {
			header: "Notificação",
			send: "Enviar Notificação",
			sending: "Envio",
			text: "Texto da Notificação",
			sendDate: "Data de Envio",
			sendHour: "Hora de Envio",
			user: "Utilizador",
			timezone: "Timezone"
		},

		publication: {
			published: "Publicado",
			publicationDate: "Data de Publicação",
			publicationHour: "Hora de Publicação"
		},

		formation: {
			header: "Biblioteca",
			type: "Tipo de formação",
			video: "Video",
			files: "Ficheiros da Formação",
			noFilesAdded: "Sem Ficheiros Adicionados",
			youtubeLink: "Link do Youtube"
		},

		promoters: {
			header: "Promotor",
			workAreas: "Áreas de Trabalho",
			importPromoters: "Importar Promotores"
		},

		serverErrors: {
			title: "Erro de Servidor",
			subTitle: "Não é você, somos nós!",
			refresh: "Voltar à Página Anterior",
			backToDashboard: "Ir para o Dashboard"
		},

		logs: {
			dateRange: "Date Range",
			userId: "User Id",
			url: "Url",
			token: "Token",
			codes: "Codes",
			methods: "Methods",
			sources: "Sources",
			types: "Types"
		}
	},

	/* cSpell.language:gr */
	gr: {
		generic: {
			edit: "Επεξεργασία",
			done: "Ολοκληρώθηκε",
			accept: "Αποδοχή",
			cancel: "Ακύρωση",
			remove: "Αφαίρεση",
			delete: "Διαγραφή",
			success: "Επιτυχία",
			active: "Ενεργό",
			expand: "Επέκταση",
			toggle: "Τροποποίηση",
			save: "Αποθήκευση",
			yes: "Ναι",
			no: "Όχι",
			apply: "Εφαρμογή",
			item: "Άρθρο",
			items: "Άρθρα",
			submit: "Υποβολή",
			continue: "Συνέχεια",
			confirm: "Επιβεβαίωση",
			finish: "Τέλος",
			back: "Πίσω",
			oops: "Ουπς",
			error: "Σφάλμα",
			retry: "Προσπάθεια Ξανά",
			reset: "Επαναφορά",
			search: "Αναζήτηση",
			noResults: "Χωρίς Αποτελέσματα",
			clickHereTo: "Κάντε κλικ εδώ για {0}",
			requiredField: "{0} είναι ένα υποχρεωτικό πεδίο",
			duplicateEmail: "Αυτό το email χρησιμοποιείται ήδη. Παρακαλώ χρησιμοποιήστε άλλο email.",
			emptyList: "Χωρίς {0} στη λίστα",
			leavePage: "Έξοδος από τη σελίδα?",
			leave: "Έξοδος",
			stay: "Μείνετε",
			open: "Άνοιγμα",
			close: "Κλείσιμο",
			change: "Αλλαγή",
			free: "Δωρεάν",
			send: "Αποστολή",
			selected: "Επιλεγμένο",
			selecteds: "Επιλεγμένα",
			swalEditTitle: "Ακύρωση Αλλαγής?",
			swalEditDescription: "Η ακύρωση της επεξεργασίας θα διαγράψει όλη η μη αποθηκευμένη πληροφορία",
			leaveDescription: "Όταν βγείτε από αυτήν τη σελίδα θα διαγράψετε όλη η μη αποθηκευμένη πληροφορία",
			swalDeleteTitle: "Διαγραφή {0}?",
			swalDeleteDescription: "Όταν βγείτε από αυτήν τη σελίδα θα διαγράψετε όλα τα {0} στη λίστα σας",
			genericSelect: "Επιλέξτε {0}",
			select: "Επιλέξτε",
			addGeneric: "Προσθήκη {0}",
			moreOptions: "Περισσότερες Επιλογές",
			all: "Όλα",
			enable: "Ενεργό",
			newF: "Νέο",
			newM: "Νέο",
			addNewF: "Προσθήκη νέου {0}",
			addNewM: "Προσθήκη νέου {0}",
			addNew: "Προσθήκη {0}",
			default: "Προεπιλογή",
			editGeneric: "Επεξεργασία {0}",
			infinite: "Infinito",
			details: "Λεπτομέρειες",
			noItemsSelected: "Χωρίς Επιλεγμένα Αντικείμενα",
			clearList: "Καθαρισμός λίστας",
			loading: "Γίνεται φόρτωση...",
			view: "Προβολή",
			actions: "Ενέργειες",
			invalidUrl: "URL δεν είναι έγκυρος. Παρακαλώ αφαιρέστε το prefixo HTTP.",
			shop: "Χώρος",
			noEntries: "Χωρίς Τιμές",
			chatWalktroughText1:
				"Προσθέσαμε διάφορες συχνές ερωτήσεις που μπορούν να σας βοηθήσουν να καταλάβετε και να κατανοήσετε πώς λειτουργεί το προϊόν Shop2Grow. Οι συχνές ερωτήσεις είναι διαθέσιμες στο εικονίδιο chat στην κάτω δεξιά γωνία της οθόνης.",
			chatWalktroughText2:
				"Είμαστε επίσης διαθέσιμοι, μέσω chat, για να σας βοηθήσουμε να δημιουργήσετε και να ορίσετε το προϊόν Shop2Grow.",
			skip: "Παράλειψη",
			walkTrough: "Περιήγηση",
			clone: "Κλώνος",
			download: "Λήψη",
			upload: "Ανεβάστε",
			template: "Λήψη Προτύπου",
			export: "Εξαγωγή",
			import: "Εισαγωγή",
			defaultItem: "ένα αντικείμενο",
			defaultItemRecipient: "αυτό/αυτή {0}",
			demo: "Δείγμα",
			previewOnly: "Προεπισκόπηση",
			selectPaymentMethod: "Παρακαλώ επιλέξτε ένα μέθοδο πληρωμής πριν ανανεώσετε την υπηρεσία σας.",
			basic: "Βασικό",
			advanced: "Προχωρημένο",
			editMode: "Τρόπος Επεξεργασίας",
			print: "Εκτύπωση",
			code: "Κωδικός",
			percentage: "Ποσοστό",
			yesDelete: "Ναι, διαγράψτε!"
		},
		fields: {
			name: "Όνομα",
			address: "Διεύθυνση",
			addresses: "Διευθύνσεις",
			country: "Χώρα",
			state: "Νομός",
			counties: "Περιφερειακές Ενότητες",
			county: "Περιφερειακή Ενότητα",
			city: "Πόλη",
			type: "Τύπος",
			zipCode: "Κωδικός Πολυόρου",
			description: "Περιγραφή",
			phone: "Τηλέφωνο",
			phoneNumber: "Αριθμός Τηλεφώνου",
			phoneShort: "Tel.:",
			mobilePhone: "Telemóvel",
			email: "Email",
			acceptMarketing: "Marketing",
			seoUrl: "SEO Url",
			tags: "Ετικέτες",
			ccNumber: "Αριθμός CC",
			billingAddress: "Παραγγελία",
			shippingAddress: "Παραγγελία",
			vat: "ΦΠΑ",
			password: "Κωδικός",
			message: "Μήνυμα",
			image: "Εικόνα",
			images: "Εικόνες",
			logo: "Logo",
			imgPlaceholder: "Προσπαθήστε να σύρετε εικόνες εδώ, ή κάντε κλικ για να κάνετε upload",
			filesPlaceholder: "Προσπαθήστε να σύρετε το αρχείο εδώ ή κάντε κλικ για να επιλέξετε το αρχείο",
			subTotal: "Υποσύνολο",
			total: "Σύνολο",
			quantity: "Ποσότητα",
			ordered: "Ποσότητα Παραγγελίας",
			totalQuantity: "Συνολική Ποσότητα",
			discount: "Έκπτωση",
			registerDate: "Data Registo",
			invalidEmail: "Email δεν είναι έγκυρος",
			tax: "Φόρος",
			addedOn: "Προστέθηκε",
			startDate: "Ημερομηνία Έναρξης",
			endDate: "Ημερομηνία Λήξης",
			startHour: "Ώρα Έναρξης",
			endHour: "Ώρα Λήξης",
			filename: "Όνομα Αρχείου",
			gender: "Φύλο",
			waitingForResults: "Αναμονή για το όνομα ή SKU...",
			link: "Σύνδεσμος",
			date: "Ημερομηνία",
			otherRegions: "Άλλες Περιοχές",
			taxValues: "Φόροι",
			previewLink: "Σύνδεσμος Προεπισκόπησης",
			clickToUpload: "Κάντε κλικ για να κάνετε το Upload",
			photo: "Φωτογραφία",
			file: "Αρχείο",

			// Select
			selectCountry: "Επιλέξτε Χώρα",
			selectState: "Επιλέξτε Νομό",
			selectFilters: "Επιλέξτε Φίλτρα",
			selectDiscount: "Επιλέξτε Έκπτωση",

			countries: "Χώρες",
			states: "Νομοί",

			// Pairs
			valuePair: "{0} / {1}",
			placeHolderPair: "{0} => {1}",

			code: "Ακρωνύμιο",
			bccEmail: "Email για να λάβετε παραγγελίες"
		},
		language: {
			header: "Γλώσσα",
			defaultLanguage: "Γλώσσα Προεπιλογής",
			languageNotActive: "Κρατήστε τις ενημερώσεις πριν προχωρήσετε στην αλλαγή της γλώσσας προεπιλογής.",
			portuguese: "Πορτογαλικά",
			english: "Αγγλικά",
			german: "Γερμανικά",
			french: "Γαλλικά",
			spanish: "Ισπανικά",
			greek: "Γαλλικά"
		},
		sidebar: {
			dashboard: "Πίνακας Ελέγχου",
			profile: "Προφίλ",
			information: "Πληροφορίες",
			promoters: "Προμηθευτές",
			settings: "Ρυθμίσεις",
			logs: "Καταγραφές",
			users: "Χρήστες",
			staff: "Προσωπικό",
			products: "Προϊόντα",
			cultures: "Καλλιέργειες",
			nutrients: "Νιτρικά",
			news: "Νέα",
			formations: "Βιβλιοθήκη",
			notifications: "Ειδοποιήσεις",
			documents: "Έγγραφα",
			fertilizingTypes: "Τύποι Φυτικής Υγιεινής"
		},
		header: {
			daysLeft: "Ημέρες που απομένουν στην δοκιμαστική περίοδος",
			upgrade: "Αναβάθμιση",
			account: "Λογαριασμός",
			maintenance: "Διατήρηση",
			visitStore: "Επισκεφθείτε την Εταιρεία",
			deleteSuccess: "Τα προσωρινά δεδομένα διαγράφηκαν με επιτυχία",
			extend: "Επέκταση Trial"
		},
		authentication: {
			welcome: "Γεια σας",
			header: "Πιστοποίηση",
			register: "Εγγραφή",
			login: "Σύνδεση",
			logout: "Αποσύνδεση",
			signIn: "Πιστοποίηση",
			confirmAccount: "Επιβεβαίωση λογαριασμού",
			name: "Όνομα",
			namePlaceholder: "Το όνομά σας",
			email: "Email",
			emailPlaceholder: "Το email σας",
			password: "Κωδικός",
			passwordPlaceholder: "Ο κωδικός σας",
			newPassword: "Νέος κωδικός",
			newPasswordPlaceholder: "Εισάγετε νέο κωδικό",
			confirmPassword: "Επιβεβαίωση κωδικού",
			confirmPasswordPlaceholder: "Επιβεβαίωση κωδικού",
			forgotPassword: "Ξεχάσατε τον κωδικό?",
			loginFooter: "Δεν έχετε λογαριασμό? Εγγραφείτε εδώ",
			registerFooter: "Έχετε λογαριασμό? Είσοδος εδώ.",
			resendCode1: "Δεν λάβατε τον κωδικό επαλήθευσης; ",
			resendCode2: "Αποστολή κωδικού επαλήθευσης",
			sendEmail: "Αποστολή Email",
			recoverPassword: "Ανακατάληψη κωδικού",
			changePassword: "Αλλαγή κωδικού",
			changeEmail: "Αλλαγή Email",
			newEmail: "Νέος Email",
			newEmailConfirm: "Επιβεβαίωση νέου Email",
			repeatEmail: "Επανάληψη Email",
			currentEmail: "Τρέχων Email",
			currentPassword: "Τρέχων κωδικός",
			emailSent: "Email αποσταλμένος με επιτυχία",
			repeatPassword: "Επανάληψη κωδικού",
			rememberedPassword: "Έχετε θυμηθεί τον κωδικό;",
			adminPassword: "Κωδικός διαχειριστή",
			notLoggedIn: "Χρειάζεται να είστε συνδεδεμένοι για να έχετε πρόσβαση σε αυτήν την σελίδα",
			noMatchPassword: "Οι κωδικοί δεν ταιριάζουν",
			acceptSubtitle: "Παρακαλώ εισάγετε ένα κωδικό πρόσβασης για να επιβεβαιώσετε το λογαριασμό σας.",
			goBackToLogin: "Επιστροφή στην σελίδα σύνδεσης",
			resendInviteEmail: "Αποστολή email εγγραφής",
			confirmResendInviteEmail: "Αποστολή email εγγραφής για {0}?"
		},
		acceptInvite: {
			header: "Αποδοχή Εγγραφής",
			title: "Γεια σας {0}, {1} σας προσκάλεσε να διαχειριστείτε το {2}.",
			subTitle: "Εισάγετε μια κωδικό πρόσβασης για να επιβεβαιώσετε το λογαριασμό σας",
			expired: "Ο εντοπισμός έχει λήξει"
		},
		notFound: {
			header: "Σελίδα Χωρίς Υπάρξη"
		},
		importModal: {
			fileName: "Όνομα Αρχείου",
			size: "Μέγεθος",
			import: "Εισαγωγή"
		},
		errors: {
			invalidArgs: "Άκυρες ορίσματα ή άδειες",
			invalidFields: "Άκυροι πεδία ή άδειες",
			emailIsInvalid: "Το email που εισήχθη δεν είναι έγκυρο",
			videoUrlIsInvalid: "Η διεύθυνση του βίντεο δεν είναι έγκυρη",
			fillEmail: "Παρακαλώ εισάγετε ένα email",
			fillPassword: "Παρακαλώ εισάγετε μια κωδικό πρόσβασης",
			pleaseFillFormCorrectly: "Παρακαλώ συμπληρώστε το πεδίο σωστά",
			fillField: "Το πεδίο είναι υποχρεωτικό",
			notSupportedFile: "Το αρχείο δεν υποστηρίζεται",
			nameIsEmpty: "Το πεδίο όνομα είναι υποχρεωτικό",
			passwordsDontMatch: "Οι κωδικοί πρόσβασης δεν ταιριάζουν",
			emailIsEmpty: "Το πεδίο email είναι υποχρεωτικό",
			fileTooBigorInvalid: "Το αρχείο είναι πολύ μεγάλο ή είναι άκυρο",
			couldNotImportProduct: "Δεν ήταν δυνατή η εισαγωγή του προϊόντος",
			selectCountryFirst: "Παρακαλώ επιλέξτε μια χώρα πρώτα",
			cantDrag: "Δεν είναι δυνατή η ταξινόμηση των στοιχείων σε αυτήν την στιγμή"
		},
		profile: {
			profilePicture: "Φωτογραφία προφίλ",
			role: "Ρόλος",
			editedSuccessfully: "Το προφίλ ενημερώθηκε με επιτυχία"
		},
		placeholders: {
			name: "Το όνομά σας",
			email: "Το email σας",
			phoneNumber: "Το αριθμό τηλεφώνου σας",
			language: "Επιλέξτε μια γλώσσα",
			role: "Επιλέξτε ένα ρόλο",
			currentPassword: "Τρέχων κωδικός",
			newPassword: "Νέος κωδικός",
			confirmPassword: "Επιβεβαίωση κωδικού",
			newEmail: "Νέος email",
			page: "Σελίδα",
			titlePage: "Τίτλος σελίδας",
			link: "https://www.google.com/"
		},
		staff: {
			owner: "Άρχων",
			admin: "Διαχειριστής",
			editedSuccessfully: "Ο χρήστης ενημερώθηκε με επιτυχία",
			passwordChangedSuccessfully: "Ο κωδικός αλλάχτηκε με επιτυχία",
			emailChangedSuccessfully: "Ο email αλλάχτηκε με επιτυχία",
			wrongPassword: "Ο κωδικός είναι λανθασμένος",
			emailInUse: "Ο email χρησιμοποιείται",
			status: "Κατάσταση",
			confirmed: "Επιβεβαιωμένο",
			pending: "Προσωρινό"
		},
		ranges: {
			today: "Σήμερα",
			thisMonth: "Αυτός ο μήνας",
			lastMonth: "Τελευταίος μήνας",
			thisYear: "Αυτό το χρόνο",
			lastYear: "Τελευταίος χρόνος"
		},
		dashboard: {
			period: "Περίοδος",
			active: "Ενεργό",
			homepage: "Αρχική",
			inStock: "Σε απόθεμα",
			daily: "Ημερήσιο",
			monthly: "Μηνιαίο",
			newUsers: "Νέοι χρήστες",
			newUsersContent: "Νέοι χρήστες περιεχόμενο",
			uses: "Χρήσεις",
			androidUse: "Χρήση Android",
			androidUseContent: "Χρήση Android περιεχόμενο",
			iOSUse: "Χρήση iOS",
			iOSUseContent: "Χρήση iOS περιεχόμενο",
			webUse: "Χρήση Web",
			webUseContent: "Χρήση Web περιεχόμενο"
		},
		settings: {
			pages: "Σελίδες",
			emailTemplates: "Πρότυπα Email",
			soilNutrients: "Νιτρικά στοιχεία του εδάφους",
			fertilizingTypes: "Τύποι εφαρμογής λιπάσματος",
			lines: "Τρόποι εφαρμογής",
			dichotomousKey: "Κλειδί Διχοτομικό",
			agronomicServices: "Υπηρεσίες Αγροτικής Επιστήμης",
			libraryTypes: "Τύποι βιβλιοθηκών"
		},
		pages: {
			single: "Σελίδα",
			title: "Τίτλος",
			content: "Περιεχόμενο",
			new: "Νέα Σελίδα",
			isLink: "Ανακατεύθυνση"
		},
		lines: {
			header: "Τρόπος εφαρμογής",
			icon: "Εικονίδιο"
		},
		templates: {
			single: "δείγμα"
		},
		emails: {
			single: "Email",
			tags: "Ετικέτες",
			preview: "Προεπισκόπηση",
			subject: "Θέμα",
			cc: "CC"
		},
		cultures: {
			header: "Καλλιέργεια",
			file: "Αρχείο της καλλιέργειας",
			deficiencies: "Λειτουργικότητες",
			deficiency: "Λειτουργικότητα",
			correctionOfDeficiency: "Ορθοποιήσεις της Λειτουργικότητας",
			symptoms: "Συμπτώματα",
			symptom: "Συμπτώματα",
			noSymptomsAdded: "Χωρίς Συμπτώματα Προστιθέμενες",
			correction: "Ορθοποίηση",
			noCorrectionsAdded: "Χωρίς Ορθοποιήσεις Προστιθέμενες",
			toxicities: "Τοξικότητες",
			toxicity: "Τοξικότητα",
			correctionOfToxicity: "Ορθοποιήσεις της Τοξικότητας",
			mostImportantNutrients: "Βασικά Νιτρικά Στοιχεία",
			nutrientsRemovel: "Αφαίρεση Νιτρικών Στοιχείων",
			imageLandscape: "Εικόνα Εικονίδιο"
		},
		fertilizing: {
			header: "Εφαρμογή λιπάσματος",
			productionDestiny: "Προορισμός παραγωγής",
			usualProduction: "Συνηθισμένη παραγωγή",
			expectedProduction: "Αναμενόμενη παραγωγή",
			production: "Παραγωγή",
			season: "Χρονιά",
			doses: "Ποσότητες",
			dose: "Ποσότητα",
			maxConcentration: "Μέγιστη συγκέντρωση",
			observations: "Σχόλια",
			fertilizingType: "Τύπος εφαρμογής λιπάσματος"
		},
		soilFertility: {
			header: "Φυσική Φυσικότητα"
		},
		nutrients: {
			header: "Νιτρικό στοιχείο",
			value: "Τιμή",
			valueLimitError: "Η τιμή πρέπει να είναι μικρότερη από 1000",
			formula: "Χημική Τύπος"
		},
		soilNutrients: {
			header: "Νιτρικό στοιχείο του εδάφους",
			veryFrequent: "Πολύ συχνό",
			frequent: "Συχνό",
			lessFrequent: "Λιγότερο συχνό"
		},
		fertilizingTypes: {
			header: "Τύπος εφαρμογής λιπάσματος"
		},
		libraryTypes: {
			header: "Τύπος βιβλιοθήκης"
		},
		dichotomousKeys: {
			header: "Διχοτομική Κλειδαριά",
			name: "Όνομα",
			description: "Περιγραφή",
			createKey: "Δημιουργήστε μια Διχοτομική Κλειδαριά",
			createName: "Καθορίστε το όνομα",
			createDescription: "Καθορίστε την περιγραφή",
			warning: "Καθώς έχετε επιλέξει ένα νιτρικό στοιχείο, δεν μπορείτε να δημιουργήσετε περισσότερες υπό-κλειδιά"
		},
		agronomicServices: {
			header: "Υπηρεσία Αγροτικής Επιστήμης",
			attachedFiles: "Αρχεία της υπηρεσίας",
			analysisTypes: "Τύποι ανάλυσης",
			analisysType: "Τύπος ανάλυσης",
			observation: "Σχόλιο",
			values: "Τιμές",

			//Analisys Types
			complete: "Ολοκληρωμένο",
			routine: "Καθημερινό",
			special: "Ειδικό"
		},
		products: {
			header: "Προϊόν",
			shortInfo: "Μικρή περιγραφή του προϊόντος",
			generalInfo: "Γενική πληροφορία του προϊόντος",
			files: "Αρχεία του προϊόντος",
			advantages: "Πλεονεκτήματα του προϊόντος",
			formulas: "Τύποι",
			formula: "Τύπος",
			formulaInformation: "Πληροφορία",
			formulaMoreInformation: "Περισσότερη πληροφορία",
			formulaFiles: "Αρχεία της τύπου",
			formulaFile: "Αρχείο της τύπου",
			fertiberiaProduct: "Προϊόν Fertiberia",
			adpProduct: "Προϊόν ADP",
			productAvailability: "Διαθέσιμο προϊόν",
			formulaAvailability: "Διαθέσιμη τύπος",
			availablePortugal: "Διαθέσιμο στην Ελλάδα",
			availableSpain: "Διαθέσιμο στην Ελλάδα",
			availableFrance: "Διαθέσιμο στην Γαλλία",
			availableGreece: "Διαθέσιμο στην Ελλάδα",
			availableOthers: "Διαθέσιμο σε άλλες χώρες",
			color: "Χρώμα του προϊόντος",
			cropsAndDoses: "Καλλιέργειες και δόσεις",
			doses: "Δόσεις",
			dose: "Δόση",
			cropAndDose: "Καλλιέργεια και δόση",
			noCropsWithDosesAdded: "Χωρίς Καλλιέργειες και δόσεις προστιθέμενες",
			slogan: "Σλογάν"
		},
		documents: {
			header: "Έγγραφο",
			file: "Αρχείο",
			documents: "Έγγραφα"
		},
		news: {
			header: "Ειδήσεις",
			schedulePublication: "Χρονοπρογραμματισμός δημοσίευσης",
			shortDescription: "Μικρή περιγραφή της ειδήσεως",
			primaryImage: "Κύρια εικόνα",
			secondaryImage: "Εικόνα των λεπτομερειών"
		},
		notifications: {
			header: "Ειδήσεις",
			send: "Αποστολή ειδήσεως",
			sending: "Αποστολή",
			text: "Κείμενο της ειδήσεως",
			sendDate: "Ημερομηνία αποστολής",
			sendHour: "Ώρα αποστολής",
			user: "Χρήστης",
			timezone: "Ζώνη ώρας"
		},
		publication: {
			published: "Δημοσιευμένο",
			publicationDate: "Ημερομηνία δημοσίευσης",
			publicationHour: "Ώρα δημοσίευσης"
		},
		formation: {
			header: "Βιβλιοθήκη",
			type: "Τύπος μορφοποίησης",
			video: "Βίντεο",
			files: "Αρχεία της μορφοποίησης",
			noFilesAdded: "Χωρίς Αρχεία Προστιθέμενες",
			youtubeLink: "Link του Youtube"
		},
		promoters: {
			header: "Προμηθευτής",
			workAreas: "Περιοχές εργασίας",
			importPromoters: "Εισαγωγή προμηθευτών"
		},
		serverErrors: {
			title: "Σφάλμα του διακομιστή",
			subTitle: "Δεν είστε εσείς, είμαστε εμείς!",
			refresh: "Επιστροφή στην προηγούμενη σελίδα",
			backToDashboard: "Επιστροφή στην πίνακα ελέγχου"
		},
		logs: {
			dateRange: "Χρονικό εύρος",
			userId: "Ταυτότητα χρήστη",
			url: "URL",
			token: "Τοκεν",
			codes: "Κωδικοί",
			methods: "Μέθοδοι",
			sources: "Πηγές",
			types: "Τύποι"
		}
	}
});
